// extracted by css-extract-rspack-plugin
export default {"root":"jLdbMDSaJQQSip5_","header":"KoPDBCtJO_sDP47T","title":"suycFII5RfIWOsCO","headerActions":"EAkrxfgf9KA3wuB0","footer":"Mk4C3jA6PvYo9Hdi"};